import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class FormGroupControl extends Vue {

  @Prop({ default: null, type: [String] })
  label: string | null;
  @Prop({ type: [String, Object] })
  xs4: string | null;
  @Prop({ type: [String, Object] })
  xs5: string | null;
  @Prop({ default: false, type: [String, Boolean] })
  required: string | null;

  get isRequired(): boolean {
    if (this.required === '' || this.required) {
      return true;
    }
    return false;
  }
  /** Props declaration */

}

export default FormGroupControl;


// WEBPACK FOOTER //
// ./src/components/control-label/index.ts